<template>
  <div class="container">
    <BlockUI :message="msg" v-show="this.loading > 0">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>
    <div class="ui grid">
      <h1>{{ title }} Company</h1>
    </div>

    <div class="ui divider"></div>

    <form class="ui form segment" @submit.prevent="companyUpdate">
      <div class="ui grid stackable">
        <div class="row">
          <div class="eight wide column">
            <label>Company Number</label>
            <input
              type="text"
              name="CompanyNumber"
              placeholder="Company Number"
              v-model="Code"
            />
          </div>

          <div class="eight wide column">
            <label>Company Name</label>
            <input
              type="text"
              name="CompanyName"
              placeholder="Company Name"
              v-model="Name"
            />
          </div>
        </div>

        <div class="row">
          <div class="sixteen wide column">
            <h4 class="ui dividing header">Plant Information</h4>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Plant Name</label>
            <input
              type="text"
              name="PlantName"
              placeholder="Plant Name"
              v-model="PlantName"
            />
          </div>

          <div class="eight wide column">
            <label>City</label>
            <input
              type="text"
              name="Plant[city]"
              placeholder="City"
              v-model="PlantCity"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address 1</label>
            <input
              type="text"
              name="Plant[address1]"
              placeholder="Address 1"
              v-model="PlantStreet"
            />
          </div>

          <div class="eight wide column">
            <label>State</label>
            <div id="stateSelect" class="ui fluid search selection dropdown">
              <input
                type="hidden"
                name="PlantState"
                v-model="PlantState"
                id="PlantState"
                @change="onPlantStateChange"
              />
              <div class="default text">Select State</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="state in statesP"
                  :key="state.value"
                  v-bind:data-value="state.value"
                >
                  {{ state.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address 2</label>
            <input
              type="text"
              name="Plant[address2]"
              placeholder="Address 2"
              v-model="PlantStreet2"
            />
          </div>

          <div class="eight wide column">
            <label>Zip</label>
            <input
              type="text"
              name="Plant[zip]"
              placeholder="Zip"
              v-model="PlantZip"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address 3</label>
            <input
              type="text"
              name="Plant[address3]"
              placeholder="Address 3"
              v-model="PlantStreet3"
            />
          </div>

          <div class="eight wide column">
            <label>Country</label>
            <div id="countrySelect" class="ui fluid search selection dropdown">
              <input
                type="hidden"
                name="PlantCountry"
                v-model="PlantCountry"
                id="PlantCountry"
                @change="onPlantCountryChange"
              />
              <div class="default text">Select Country</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="country in countriesP"
                  :key="country.value"
                  v-bind:data-value="country.value"
                >
                  <i :class="country.flag" class="flag"></i>
                  {{ country.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="sixteen wide column">
            <h4 class="ui dividing header">Ship To Information</h4>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Ship To Name</label>
            <input
              type="text"
              name="ShipToName"
              placeholder="Ship to Name"
              v-model="ShipToName"
            />
          </div>

          <div class="eight wide column">
            <label>City</label>
            <input
              type="text"
              name="Shipto[city]"
              placeholder="City"
              v-model="ShipToCity"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address 1</label>
            <input
              type="text"
              name="Shipto[address1]"
              placeholder="Address 1"
              v-model="ShipToStreet"
            />
          </div>

          <div class="eight wide column">
            <label>State</label>
            <div
              id="ShipToStateSelect"
              class="ui fluid search selection dropdown"
            >
              <input
                type="hidden"
                name="ShipToState"
                v-model="ShipToState"
                id="ShipToState"
                @change="onShipToStateChange"
              />
              <div class="default text">Select State</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="state in statesS"
                  :key="state.value"
                  v-bind:data-value="state.value"
                >
                  {{ state.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address 2</label>
            <input
              type="text"
              name="Shipto[address2]"
              placeholder="Address 2"
              v-model="ShipToStreet2"
            />
          </div>

          <div class="eight wide column">
            <label>Zip</label>
            <input
              type="text"
              name="Shipto[zip]"
              placeholder="Zip"
              v-model="ShipToZip"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Address 3</label>
            <input
              type="text"
              name="Shipto[address3]"
              placeholder="Address 3"
              v-model="ShipToStreet3"
            />
          </div>

          <div class="eight wide column">
            <label>Country</label>
            <div
              id="ShipToCountrySelect"
              class="ui fluid search selection dropdown"
            >
              <input
                type="hidden"
                name="ShipToCountry"
                v-model="ShipToCountry"
                id="ShipToCountry"
                @change="onShipToCountryChange"
              />
              <div class="default text">Select Country</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="country in countriesS"
                  :key="country.value"
                  v-bind:data-value="country.value"
                >
                  <i :class="country.flag" class="flag"></i>
                  {{ country.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="sixteen wide column">
            <div class="ui divider"></div>
          </div>
        </div>

        <div class="row">
          <div class="sixteen wide column">
            <label>Instructions</label>
            <input
              type="text"
              name="Instructions"
              placeholder="Instructions"
              v-model="Instructions"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label for="Active" class="toggle label">InActive</label>
            <div class="ui toggle checkbox">
              <input
                id="Active"
                name="Active"
                type="checkbox"
                tabindex="0"
                class
                v-model="Active"
              />
              <label for="Active">Active</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">{{ button }} Company</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import { mapGetters } from "vuex";

export default {
  name: "ManageCompanies",
  computed: {
    ...mapGetters({ loading: "loading" }),
  },
  components: {},
  mounted() {
    $(".ui.dropdown").dropdown({
      fullTextSearch: true,
      sortSelect: true,
      match: "text",
    });

    if (this.$route.params.id == undefined) {
      this.PlantCountry = "US";
      this.ShipToCountry = "US";
      this.button = "Add";
      this.title = "Add";
    } else {
      this.companyDetails();
      this.button = "Save";
      this.title = "Edit";
    }
  },
  data() {
    return {
      Name: "",
      Code: "",
      Instructions: "",
      Active: true,
      Plant: {},
      PlantName: "",
      PlantStreet: "",
      PlantStreet2: "",
      PlantStreet3: "",
      PlantCity: "",
      PlantZip: "",
      PlantState: "",
      PlantCountry: "",
      ShipTo: {},
      ShipToName: "",
      ShipToStreet: "",
      ShipToStreet2: "",
      ShipToStreet3: "",
      ShipToCity: "",
      ShipToZip: "",
      ShipToState: "",
      ShipToCountry: "",
      statesP: [],
      countriesP: [],
      statesS: [],
      countriesS: [],
      showModal: false,
      button: "",
      title: "",
      msg: "Loading . . .",
    };
  },
  methods: {
    companyDetails() {
      apiService
        .getCompanyDetails({ id: this.$route.params.id })
        .then((request) => {
          this.companySuccessful(request);
        })
        .then(() => {
          this.getStates(this.PlantCountry, "P");
          this.getStates(this.ShipToCountry, "S");
        })
        .catch((err) => this.companyFailed(err));
    },
    companySuccessful(request) {
      (this.Name = request.name),
        (this.Code = request.code),
        (this.Plant = request.plant),
        (this.PlantName = request.plant.name),
        (this.PlantStreet = request.plant.street),
        (this.PlantStreet2 = request.plant.street2),
        (this.PlantStreet3 = request.plant.street3),
        (this.PlantCity = request.plant.city),
        (this.PlantZip = request.plant.postalCode),
        (this.PlantState = request.plant.state),
        (this.PlantCountry = request.plant.country),
        (this.ShipTo = request.shipTo),
        (this.ShipToName = request.shipTo.name),
        (this.ShipToStreet = request.shipTo.street),
        (this.ShipToStreet2 = request.shipTo.street2),
        (this.ShipToStreet3 = request.shipTo.street3),
        (this.ShipToCity = request.shipTo.city),
        (this.ShipToZip = request.shipTo.postalCode),
        (this.ShipToState = request.shipTo.state),
        (this.ShipToCountry = request.shipTo.country),
        (this.Instructions = request.instructions),
        (this.Active = request.active);
      this.getCountries("P");
      this.getCountries("S");
    },
    companyFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    companyUpdate() {
      if (this.$route.params.id == undefined) {
        apiService
          .createCompany({
            name: this.Name,
            code: this.Code,
            instructions: this.Instructions,
            active: this.Active,
            plant: {
              name: this.PlantName,
              street: this.PlantStreet,
              street2: this.PlantStreet2,
              street3: this.PlantStreet3,
              city: this.PlantCity,
              postalCode: this.PlantZip,
              state: this.PlantState,
              country: this.PlantCountry,
            },
            shipTo: {
              name: this.ShipToName,
              street: this.ShipToStreet,
              street2: this.ShipToStreet2,
              street3: this.ShipToStreet3,
              city: this.ShipToCity,
              postalCode: this.ShipToZip,
              state: this.ShipToState,
              country: this.ShipToCountry,
            },
          })
          .then(() => {
            // this.conpanySuccessful(request);
            this.$router.push("/admin/company/index");
          })
          .catch((err) => this.companyFailed(err));
      } else {
        apiService
          .updateCompany({
            id: this.$route.params.id,
            name: this.Name,
            code: this.Code,
            instructions: this.Instructions,
            active: this.Active,
            plant: {
              name: this.PlantName,
              street: this.PlantStreet,
              street2: this.PlantStreet2,
              street3: this.PlantStreet3,
              city: this.PlantCity,
              postalCode: this.PlantZip,
              state: this.PlantState,
              country: this.PlantCountry,
            },
            shipTo: {
              name: this.ShipToName,
              street: this.ShipToStreet,
              street2: this.ShipToStreet2,
              street3: this.ShipToStreet3,
              city: this.ShipToCity,
              postalCode: this.ShipToZip,
              state: this.ShipToState,
              country: this.ShipToCountry,
            },
          })
          .then(() => {
            // this.companySuccessful(request);
            this.$router.push("/admin/company/index");
          })
          .catch((err) => this.companyFailed(err));
      }
    },
    onPlantStateChange(event) {
      this.PlantState = event.target.value;
    },
    onShipToStateChange(event) {
      this.ShipToState = event.target.value;
    },
    onShipToCountryChange(event) {
      this.ShipToCountry = event.target.value;
      this.getStates(this.ShipToCountry, "S");
    },
    onPlantCountryChange(event) {
      this.PlantCountry = event.target.value;
      this.getStates(this.PlantCountry, "P");
    },
    getStates(country, type) {
      var states = [];
      if (type == "P") {
        $("#stateSelect").dropdown("destroy");
      }
      if (type == "S") {
        $("#ShipToStateSelect").dropdown("destroy");
      }

      if (country == "") {
        country = "US";
      }
      apiService
        .getStatesByCountry(country)
        .then((data) => {
          for (var i = 0; i < data.length; i++) {
            var state = {
              key: data[i].code,
              value: data[i].code,
              flag: data[i].code.toLowerCase(),
              text: data[i].name,
            };
            states.push(state);
          }

          if (type == "P") {
            this.statesP = states;
          }
          if (type == "S") {
            this.statesS = states;
          }
        })
        .then(() => {
          if (type == "P") {
            $("#stateSelect").dropdown({
              fullTextSearch: true,
              sortSelect: true,
              match: "text",
            });
          }
          if (type == "S") {
            $("#ShipToStateSelect").dropdown({
              fullTextSearch: true,
              sortSelect: true,
              match: "text",
            });
          }
        });
    },
    getCountries(type) {
      let _this = this;
      var countries = [];
      if (type == "P") {
        $("#countrySelect").dropdown("destroy");
      }
      if (type == "S") {
        $("#ShipToCountrySelect").dropdown("destroy");
      }
      apiService
        .getCountries()
        .then((data) => {
          for (var i = 0; i < data.length; i++) {
            var country = {
              key: data[i].code,
              value: data[i].code,
              flag: data[i].code.toLowerCase(),
              text: data[i].name,
            };
            countries.push(country);
          }
          if (type == "P") {
            _this.countriesP = countries;
          }
          if (type == "S") {
            _this.countriesS = countries;
          }
        })
        .then(() => {
          if (type == "P") {
            $("#countrySelect").dropdown({
              fullTextSearch: true,
              sortSelect: true,
              match: "text",
            });
            $("#countrySelect").dropdown("set selected", _this.PlantCountry);
          }
          if (type == "S") {
            $("#ShipToCountrySelect").dropdown({
              fullTextSearch: true,
              sortSelect: true,
              match: "text",
            });
            $("#ShipToCountrySelect").dropdown("set selected", _this.ShipToCountry);
          }
        });
    },
  },
};
</script>

<style module></style>
